/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CheckoutRequest,
    CheckoutRequestFromJSON,
    CheckoutRequestToJSON,
    CheckoutResponse,
    CheckoutResponseFromJSON,
    CheckoutResponseToJSON,
    InstallationSubscription,
    InstallationSubscriptionFromJSON,
    InstallationSubscriptionToJSON,
    PortalResponse,
    PortalResponseFromJSON,
    PortalResponseToJSON,
} from '../models';

export interface CancelSubscriptionRequest {
    installationId: number;
}

export interface GetBillingPortalUrlRequest {
    installationId: number;
}

export interface GetInstallationSubscriptionRequest {
    installationId: number;
}

export interface InitiateCheckoutRequest {
    installationId: number;
    checkoutRequest: CheckoutRequest;
}

export interface ReactivateSubscriptionRequest {
    installationId: number;
}

/**
 * BillingApi - interface
 * 
 * @export
 * @interface BillingApiInterface
 */
export interface BillingApiInterface {
    /**
     * 
     * @summary Cancel the active subscription
     * @param {number} installationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    cancelSubscriptionRaw(requestParameters: CancelSubscriptionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>>;

    /**
     * Cancel the active subscription
     */
    cancelSubscription(requestParameters: CancelSubscriptionRequest, initOverrides?: RequestInit): Promise<void>;

    /**
     * 
     * @summary Get the billing management portal URL
     * @param {number} installationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingPortalUrlRaw(requestParameters: GetBillingPortalUrlRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PortalResponse>>;

    /**
     * Get the billing management portal URL
     */
    getBillingPortalUrl(requestParameters: GetBillingPortalUrlRequest, initOverrides?: RequestInit): Promise<PortalResponse>;

    /**
     * 
     * @summary Get the subscription for an installation
     * @param {number} installationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getInstallationSubscriptionRaw(requestParameters: GetInstallationSubscriptionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InstallationSubscription>>;

    /**
     * Get the subscription for an installation
     */
    getInstallationSubscription(requestParameters: GetInstallationSubscriptionRequest, initOverrides?: RequestInit): Promise<InstallationSubscription>;

    /**
     * 
     * @summary Initiate a checkout or plan change
     * @param {number} installationId 
     * @param {CheckoutRequest} checkoutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    initiateCheckoutRaw(requestParameters: InitiateCheckoutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CheckoutResponse>>;

    /**
     * Initiate a checkout or plan change
     */
    initiateCheckout(requestParameters: InitiateCheckoutRequest, initOverrides?: RequestInit): Promise<CheckoutResponse>;

    /**
     * 
     * @summary Reactivate a subscription pending cancellation
     * @param {number} installationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    reactivateSubscriptionRaw(requestParameters: ReactivateSubscriptionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>>;

    /**
     * Reactivate a subscription pending cancellation
     */
    reactivateSubscription(requestParameters: ReactivateSubscriptionRequest, initOverrides?: RequestInit): Promise<void>;

}

/**
 * 
 */
export class BillingApi extends runtime.BaseAPI implements BillingApiInterface {

    /**
     * Cancel the active subscription
     */
    async cancelSubscriptionRaw(requestParameters: CancelSubscriptionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling cancelSubscription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/installations/{installationId}/billing/subscription/cancel`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel the active subscription
     */
    async cancelSubscription(requestParameters: CancelSubscriptionRequest, initOverrides?: RequestInit): Promise<void> {
        await this.cancelSubscriptionRaw(requestParameters, initOverrides);
    }

    /**
     * Get the billing management portal URL
     */
    async getBillingPortalUrlRaw(requestParameters: GetBillingPortalUrlRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PortalResponse>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling getBillingPortalUrl.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/installations/{installationId}/billing/portal`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalResponseFromJSON(jsonValue));
    }

    /**
     * Get the billing management portal URL
     */
    async getBillingPortalUrl(requestParameters: GetBillingPortalUrlRequest, initOverrides?: RequestInit): Promise<PortalResponse> {
        const response = await this.getBillingPortalUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the subscription for an installation
     */
    async getInstallationSubscriptionRaw(requestParameters: GetInstallationSubscriptionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InstallationSubscription>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling getInstallationSubscription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/installations/{installationId}/billing/subscription`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstallationSubscriptionFromJSON(jsonValue));
    }

    /**
     * Get the subscription for an installation
     */
    async getInstallationSubscription(requestParameters: GetInstallationSubscriptionRequest, initOverrides?: RequestInit): Promise<InstallationSubscription> {
        const response = await this.getInstallationSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiate a checkout or plan change
     */
    async initiateCheckoutRaw(requestParameters: InitiateCheckoutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CheckoutResponse>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling initiateCheckout.');
        }

        if (requestParameters.checkoutRequest === null || requestParameters.checkoutRequest === undefined) {
            throw new runtime.RequiredError('checkoutRequest','Required parameter requestParameters.checkoutRequest was null or undefined when calling initiateCheckout.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/web/installations/{installationId}/billing/checkout`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckoutRequestToJSON(requestParameters.checkoutRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckoutResponseFromJSON(jsonValue));
    }

    /**
     * Initiate a checkout or plan change
     */
    async initiateCheckout(requestParameters: InitiateCheckoutRequest, initOverrides?: RequestInit): Promise<CheckoutResponse> {
        const response = await this.initiateCheckoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reactivate a subscription pending cancellation
     */
    async reactivateSubscriptionRaw(requestParameters: ReactivateSubscriptionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling reactivateSubscription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/installations/{installationId}/billing/subscription/reactivate`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reactivate a subscription pending cancellation
     */
    async reactivateSubscription(requestParameters: ReactivateSubscriptionRequest, initOverrides?: RequestInit): Promise<void> {
        await this.reactivateSubscriptionRaw(requestParameters, initOverrides);
    }

}
